<template>
  <PrismicText
    v-bind="{
      ...props,
      wrapper,
    }"
  />
</template>

<script setup lang="ts">
import type { PrismicTextProps } from '@prismicio/vue';
import { computed } from 'vue';

const props = defineProps<PrismicTextProps>();

const wrapper = computed(() => {
  if (props.wrapper) {
    return props.wrapper;
  }

  switch (props.field?.[0]?.type) {
    case 'heading1':
      return 'h1';
    case 'heading2':
      return 'h2';
    case 'heading3':
      return 'h3';
    case 'heading4':
      return 'h4';
    case 'heading5':
      return 'h5';
    case 'heading6':
      return 'h6';
    default:
      return 'span';
  }
});
</script>
